import React from 'react';
import {ReactSVG} from "react-svg";

export function getImagIcon(iconName : string , className : string , disabled : boolean = false) {
  let iconPath = '';
  switch (iconName) {
    case  'lock': {
      iconPath = '../../../static/icons/lock.svg';
      break;
    }
    case  'info_outline': {
      iconPath = '../../../static/icons/info_outline.svg';
      break;
    }
    case  'email': {
      iconPath = '../../../static/icons/email-white.svg';
      break;
    }
    default : return '';
  }
  return (<ReactSVG src={iconPath}
                    data-at={`icon-${iconName}`}
                    wrapper={'span'}
                    className={`wrapper-icon ${className} ${iconName} ${disabled ? 'disabled' : ''}`}/>);
}



// WEBPACK FOOTER //
// ./src/utils/iconHelper.js